import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import "./EditProducts.css";
import AdminNavBar from "./AdminNavBar";

const EditProducts = () => {
  const [products, setProducts] = useState(null); // null = loading

  console.log("🔵 EditProducts render start");

  useEffect(() => {
    async function load() {
      console.log("📥 Loading products from Firestore...");

      try {
        const snap = await getDocs(collection(db, "products"));
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        console.log("✅ Products loaded:", list);
        setProducts(list);
      } catch (err) {
        console.error("❌ Error loading products:", err);
        setProducts([]); // prevent infinite loading
      }
    }

    load();
  }, []);

  const updateField = async (id, field, value) => {
    console.log(`✏️ Updating product ${id} field ${field} →`, value);

    try {
      await updateDoc(doc(db, "products", id), { [field]: value });
    } catch (err) {
      console.error("❌ Update failed:", err);
    }
  };

  // Loading guard
  if (!products) {
    return <div className="loading">Loading products...</div>;
  }

  return (
    <div className="edit-home">

      <AdminNavBar />

      <div className="edit-products">
        <h1>Edit Products</h1>

        {products.length === 0 && (
          <p>No products found in Firestore.</p>
        )}

        {products.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Price</th>
                <th>Amazon Link</th>
                <th>Featured</th>
              </tr>
            </thead>

            <tbody>
              {products.map((p) => (
                <tr key={p.id}>
                  <td>
                    <input
                      defaultValue={p.title}
                      onBlur={(e) => updateField(p.id, "title", e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      defaultValue={p.price}
                      onBlur={(e) => updateField(p.id, "price", e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      defaultValue={p.amazonLink}
                      onBlur={(e) => updateField(p.id, "amazonLink", e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      type="checkbox"
                      defaultChecked={p.featured}
                      onChange={(e) =>
                        updateField(p.id, "featured", e.target.checked)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default EditProducts;
